/* @flow */

import {metaAnn as meta} from 'reactive-di-observable/plugins/meta/meta'
import {setterAnn as setter} from 'reactive-di-observable/plugins/setter/setter'
import {computedAnn as computed} from 'reactive-di-observable/plugins/computed/computed'
import {observableAnn as observable} from 'reactive-di-observable/plugins/observable/observable'
import {componentAnn as component} from 'reactive-di-observable/plugins/component/component'
import {themeAnn as theme} from 'reactive-di-observable/plugins/theme/theme'

export {
    meta,
    setter,
    computed,
    observable,
    component,
    theme
}
